import { Button } from "@ui/Button";
import { Icon } from "@ui/Icon";
import { useAppContext } from "@ui/layouts/layoutProvider";
import { PlatformSwitch } from "@ui/layouts/PlatformSwitch";
import { HStack, Stack } from "@ui/Stack";
import { Show } from "solid-js";

type Props = {
	icon?: string;
	smallIcon?: string;
	/** Ask + Studio: product switch in place of the wordmark. */
	platformSwitch?: boolean;
};

export const SidePanelHeader = (props: Props) => {
	const { menuIsOpen, setMenuIsOpen } = useAppContext();
	const buttonLabel = () => (menuIsOpen() ? "Collapse Menu" : "Expand Menu");
	const titleSpacing = () => (menuIsOpen() ? "large" : "none");
	const symbol = () => (menuIsOpen() ? "menu_open" : "menu");
	return (
		<Stack
			class="header-stack"
			align="center"
			direction="row"
			spacing={titleSpacing()}
			justify="space-between"
		>
			<HStack align="center" spacing="medium" class="header-stack__leading">
				<Show
					when={props.platformSwitch}
					fallback={
						<Show
							when={menuIsOpen()}
							fallback={
								<Icon
									icon={props.smallIcon ?? ""}
									fillWithCurrentColor={false}
									class="collapsed-brand"
									display="inline-flex"
								/>
							}
						>
							<span class="brand-logo" innerHTML={props.icon ?? ""} />
						</Show>
					}
				>
					<div class="header-stack__switch">
						<PlatformSwitch />
					</div>
				</Show>
			</HStack>
			<Button
				variant="text"
				theme="monochrome"
				symbol={symbol()}
				symbolRelativeSize={2}
				class="menu-toggle-button"
				aria-label={buttonLabel()}
				onClick={() => setMenuIsOpen(!menuIsOpen())}
			/>
		</Stack>
	);
};
